import { notification } from 'antd';
import './notification.less';
import CheckBorderIcon from '../../assests/icons/check-border.icon';
import React from 'react';
import CloseIcon from 'assests/icons/close.icon';
import InfoBorder from 'assests/icons/info-border.icon';

function NotificationV2(placement, className, message, type = 'info', duration=5) {
  notification[type]({
    message: `${message}`,
    placement,
    className: `${className}`,
    duration: duration,
    icon: type =="success" ? <CheckBorderIcon/> : <InfoBorder />,
  });
}

export default NotificationV2;
